/**
 * Breaks down an attribute path into it's various parts, lower cases each and returns them as an ordered array.
 *
 * @param {string} attribute - Qualified attribute path.
 * @return {string[]} Individual parts of the path each as a lower case string.
 */
export default (attribute: any) => {
  // schema URN (e.g. `urn:ietf:params:scim:schemas:core:2.0:User`)
  const schema = attribute.slice(0, Math.max(0, attribute.lastIndexOf(':')))
  // pull apart nested attributes (e.g. `name.familyName`)
  const complex = attribute.slice(attribute.lastIndexOf(':') + 1).split('.')

  return [schema].concat(complex).map(part => part.toLowerCase())
}
